import { Environment } from './environment.model';

export const environment: Environment = {
  version: '1.4.0',
  envName: 'PRODUCTION',
  prod: true,
  enableSSO: true,
  hash: `${new Date().toISOString().replace(/\.|:/g, '')}`,
  interval: 15000,
  jwtToken: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyLCJpc3MiOiJNS1dlUjBudTlPQVVSOUhyanBVRzgySGJmejdaWHNJdyJ9.x1wGQ-H2QMSFFseKNe5T0xjEI7vYE5H4rhMCcMADhgI',
  jwtTokenExpiration: 3600,
  apiBaseUrls: {
    apiBase: 'https://qg5trs55t3.us-west-2.awsapprunner.com',
    gatewayBaseUrl: 'https://qg5trs55t3.us-west-2.awsapprunner.com',
  },
  apiEndpoints: {
    batchList: '/batch/',
    batchDelta: '/batch/:batchId/delta',
    partnerLogs: '/partner-logs'
  },
  batchExport: {
    localUserEmail: ''
  },
  sso: {
    clientId: '31c796a4-d89e-4f84-bd02-16e2fa47af23',
    redirectWebUri: 'https://studiopulse.nbcuni.com',
    redirectLocalUri: 'http://localhost:4200',
    authUrl: 'https://login.microsoftonline.com/4f3526f9-97d6-412d-933a-4e30a73110f4/oauth2/v2.0/authorize',
    tokenUrl: 'https://login.microsoftonline.com/4f3526f9-97d6-412d-933a-4e30a73110f4/oauth2/v2.0/token',
    scope: 'openid profile email',
    grantType: 'code',
    logoutUrl: 'https://studiopulse.nbcuni.com',
    ssoApiBaseUrl: 'https://api.studiopulse.com'
  },
  backendApiUrl: 'https://qg5trs55t3.us-west-2.awsapprunner.com'
};
